import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { HOChangePersonRequestService } from "../../../../../services/human-organization/change-person-request.service";

export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-requests-change-person", currentUserName],
    queryFn: () =>
      HOChangePersonRequestService.getMyChangePersonRequests(currentUserName),
    refetchOnMount: "always",
  });

  return response;
};
